<template>
  <lytable123 :tableData="items" :columns="columns"> </lytable123>
</template>
<script>
import lytable123 from "../lytable.vue";
export default {
  components: { lytable123 },
  data() {
    return {
      items: [
       /*  {
          carNo: "粤A5462",
          alarmName: "断电报警",
          alarmTime: "2023-04-06 12:14",
        },
        {
          carNo: "粤A5462",
          alarmName: "断电报警",
          alarmTime: "2023-04-06 12:14",
        }, */
      ],
      searchItem: {
        endTime: "",
        pageNumber: 1,
        pageSize: 12,
        sort: 2,
        startTime: "",
      },
      columns: [
        {
          title: "车牌号",
          key: "carNo",
        },
        {
          title: "报警类型",
          key: "alarmTypeName",
        },
        {
          title: "报警时间",
          key: "alarmTime2",
        },
      ],
      //http://120.25.144.155:8001/gps-d?carld=3630#/login
      //http://120.25.144.155:8001/gps-d?carld=3630
    };
  },
  methods: {
    reach(v) {
      this.searchItem.startTime = v.start;
      this.searchItem.endTime = v.end;
      //this.getData();
    },
    getData() {
      this.axios({
        method: "post",
        url: this.axios.alarm + "/alarm/list",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data.dataList;
        console.log(data);
        for (let i = 0; i < data.length; i++) {
          data[i].alarmTime2=this.utils.time(data[i].alarmTime,'yymmddhhmm')
          
        }
        this.items = data;
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/kanban/control/cheliangbaojing.vue